import React from 'react';

type IconProps = React.SVGAttributes<SVGElement> & {
	size: number;
};

const TranslationLanguages = ({
	size,
	...props
}: IconProps): React.ReactElement => (
	<svg
		width={size}
		height={size}
		viewBox="0 0 32 32"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<path d="M11 28C7.14 28 4 24.86 4 21C4 20.448 4.448 20 5 20H7C7.552 20 8 20.448 8 21C8 21.552 7.552 22 7 22H6.101C6.566 24.279 8.586 26 11 26C11.552 26 12 26.448 12 27C12 27.552 11.552 28 11 28Z" />
		<path d="M27 12H25C24.448 12 24 11.552 24 11C24 10.448 24.448 10 25 10H25.899C25.434 7.721 23.414 6 21 6C20.448 6 20 5.552 20 5C20 4.448 20.448 4 21 4C24.86 4 28 7.14 28 11C28 11.552 27.552 12 27 12Z" />
		<path d="M17 16C17.552 16 18 15.552 18 15C18 14.448 17.552 14 17 14C15.533 14 14.148 13.724 12.922 13.237C14.561 11.844 15.657 10.022 15.931 8H16.999C17.551 8 17.999 7.552 17.999 7C17.999 6.448 17.551 6 16.999 6H11.999V5C11.999 4.448 11.551 4 10.999 4C10.447 4 9.99899 4.448 9.99899 5V6H4.99899C4.44699 6 3.99899 6.448 3.99899 7C3.99899 7.552 4.44699 8 4.99899 8H6.06699C6.34099 10.022 7.43799 11.845 9.07599 13.237C7.85099 13.724 6.46599 14 4.99799 14C4.44599 14 3.99799 14.448 3.99799 15C3.99799 15.552 4.44599 16 4.99799 16C7.20999 16 9.27099 15.463 10.998 14.54C12.725 15.463 14.786 16 16.998 16H17ZM8.09299 8H13.906C13.599 9.664 12.537 11.14 10.999 12.212C9.46099 11.14 8.39999 9.664 8.09199 8H8.09299Z" />
		<path d="M27.919 26.606L22.924 14.617C22.774 14.255 22.417 14 22 14C21.583 14 21.228 14.254 21.077 14.615C21.077 14.615 16.079 26.611 16.078 26.612L16.076 26.615C16.027 26.734 15.999 26.863 15.999 27C15.999 27.552 16.447 28 16.999 28C17.416 28 17.774 27.744 17.923 27.381L19.332 24H24.665L26.075 27.385C26.226 27.746 26.582 28.001 26.998 28.001C27.55 28.001 27.998 27.553 27.998 27.001C27.998 26.861 27.969 26.728 27.917 26.607L27.919 26.606ZM20.166 22L21.999 17.6L23.832 22H20.165H20.166Z" />
	</svg>
);

export default TranslationLanguages;
